// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.0
//   protoc               v3.21.12
// source: schema.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Struct } from "./google/protobuf/struct";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "schema";

export enum UserType {
  UNDEFINED = 0,
  REVIEWER = 1,
  PROVIDER = 2,
  ADMIN = 3,
  UNRECOGNIZED = -1,
}

export function userTypeFromJSON(object: any): UserType {
  switch (object) {
    case 0:
    case "UNDEFINED":
      return UserType.UNDEFINED;
    case 1:
    case "REVIEWER":
      return UserType.REVIEWER;
    case 2:
    case "PROVIDER":
      return UserType.PROVIDER;
    case 3:
    case "ADMIN":
      return UserType.ADMIN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return UserType.UNRECOGNIZED;
  }
}

export function userTypeToJSON(object: UserType): string {
  switch (object) {
    case UserType.UNDEFINED:
      return "UNDEFINED";
    case UserType.REVIEWER:
      return "REVIEWER";
    case UserType.PROVIDER:
      return "PROVIDER";
    case UserType.ADMIN:
      return "ADMIN";
    case UserType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum CaseStatus {
  INVALID_CASE_STATUS = 0,
  PROCESSING_INPUT = 1,
  CREATING_REPORT = 2,
  REPORT_GENERATED = 3,
  GENERATION_FAILED = 4,
  PENDING_ASSIGNMENT = 5,
  PENDING_REVIEW = 6,
  REVIEW_FINALIZED = 7,
  UNRECOGNIZED = -1,
}

export function caseStatusFromJSON(object: any): CaseStatus {
  switch (object) {
    case 0:
    case "INVALID_CASE_STATUS":
      return CaseStatus.INVALID_CASE_STATUS;
    case 1:
    case "PROCESSING_INPUT":
      return CaseStatus.PROCESSING_INPUT;
    case 2:
    case "CREATING_REPORT":
      return CaseStatus.CREATING_REPORT;
    case 3:
    case "REPORT_GENERATED":
      return CaseStatus.REPORT_GENERATED;
    case 4:
    case "GENERATION_FAILED":
      return CaseStatus.GENERATION_FAILED;
    case 5:
    case "PENDING_ASSIGNMENT":
      return CaseStatus.PENDING_ASSIGNMENT;
    case 6:
    case "PENDING_REVIEW":
      return CaseStatus.PENDING_REVIEW;
    case 7:
    case "REVIEW_FINALIZED":
      return CaseStatus.REVIEW_FINALIZED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CaseStatus.UNRECOGNIZED;
  }
}

export function caseStatusToJSON(object: CaseStatus): string {
  switch (object) {
    case CaseStatus.INVALID_CASE_STATUS:
      return "INVALID_CASE_STATUS";
    case CaseStatus.PROCESSING_INPUT:
      return "PROCESSING_INPUT";
    case CaseStatus.CREATING_REPORT:
      return "CREATING_REPORT";
    case CaseStatus.REPORT_GENERATED:
      return "REPORT_GENERATED";
    case CaseStatus.GENERATION_FAILED:
      return "GENERATION_FAILED";
    case CaseStatus.PENDING_ASSIGNMENT:
      return "PENDING_ASSIGNMENT";
    case CaseStatus.PENDING_REVIEW:
      return "PENDING_REVIEW";
    case CaseStatus.REVIEW_FINALIZED:
      return "REVIEW_FINALIZED";
    case CaseStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum CancerType {
  NOT_PROVIDED = 0,
  BREAST = 1,
  THORACIC = 2,
  GI = 3,
  GU = 4,
  GYNO = 5,
  HEAD_NECK = 6,
  NEURO = 7,
  SKIN = 8,
  HEME = 9,
  OTHER = 10,
  UNRECOGNIZED = -1,
}

export function cancerTypeFromJSON(object: any): CancerType {
  switch (object) {
    case 0:
    case "NOT_PROVIDED":
      return CancerType.NOT_PROVIDED;
    case 1:
    case "BREAST":
      return CancerType.BREAST;
    case 2:
    case "THORACIC":
      return CancerType.THORACIC;
    case 3:
    case "GI":
      return CancerType.GI;
    case 4:
    case "GU":
      return CancerType.GU;
    case 5:
    case "GYNO":
      return CancerType.GYNO;
    case 6:
    case "HEAD_NECK":
      return CancerType.HEAD_NECK;
    case 7:
    case "NEURO":
      return CancerType.NEURO;
    case 8:
    case "SKIN":
      return CancerType.SKIN;
    case 9:
    case "HEME":
      return CancerType.HEME;
    case 10:
    case "OTHER":
      return CancerType.OTHER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CancerType.UNRECOGNIZED;
  }
}

export function cancerTypeToJSON(object: CancerType): string {
  switch (object) {
    case CancerType.NOT_PROVIDED:
      return "NOT_PROVIDED";
    case CancerType.BREAST:
      return "BREAST";
    case CancerType.THORACIC:
      return "THORACIC";
    case CancerType.GI:
      return "GI";
    case CancerType.GU:
      return "GU";
    case CancerType.GYNO:
      return "GYNO";
    case CancerType.HEAD_NECK:
      return "HEAD_NECK";
    case CancerType.NEURO:
      return "NEURO";
    case CancerType.SKIN:
      return "SKIN";
    case CancerType.HEME:
      return "HEME";
    case CancerType.OTHER:
      return "OTHER";
    case CancerType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum Verbosity {
  VERBOSITY_UNSPECIFIED = 0,
  VERBOSITY_LOW = 1,
  VERBOSITY_MEDIUM = 2,
  VERBOSITY_HIGH = 3,
  UNRECOGNIZED = -1,
}

export function verbosityFromJSON(object: any): Verbosity {
  switch (object) {
    case 0:
    case "VERBOSITY_UNSPECIFIED":
      return Verbosity.VERBOSITY_UNSPECIFIED;
    case 1:
    case "VERBOSITY_LOW":
      return Verbosity.VERBOSITY_LOW;
    case 2:
    case "VERBOSITY_MEDIUM":
      return Verbosity.VERBOSITY_MEDIUM;
    case 3:
    case "VERBOSITY_HIGH":
      return Verbosity.VERBOSITY_HIGH;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Verbosity.UNRECOGNIZED;
  }
}

export function verbosityToJSON(object: Verbosity): string {
  switch (object) {
    case Verbosity.VERBOSITY_UNSPECIFIED:
      return "VERBOSITY_UNSPECIFIED";
    case Verbosity.VERBOSITY_LOW:
      return "VERBOSITY_LOW";
    case Verbosity.VERBOSITY_MEDIUM:
      return "VERBOSITY_MEDIUM";
    case Verbosity.VERBOSITY_HIGH:
      return "VERBOSITY_HIGH";
    case Verbosity.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum Reasoning {
  REASONING_UNSPECIFIED = 0,
  REASONING_LOW = 1,
  REASONING_MEDIUM = 2,
  REASONING_HIGH = 3,
  UNRECOGNIZED = -1,
}

export function reasoningFromJSON(object: any): Reasoning {
  switch (object) {
    case 0:
    case "REASONING_UNSPECIFIED":
      return Reasoning.REASONING_UNSPECIFIED;
    case 1:
    case "REASONING_LOW":
      return Reasoning.REASONING_LOW;
    case 2:
    case "REASONING_MEDIUM":
      return Reasoning.REASONING_MEDIUM;
    case 3:
    case "REASONING_HIGH":
      return Reasoning.REASONING_HIGH;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Reasoning.UNRECOGNIZED;
  }
}

export function reasoningToJSON(object: Reasoning): string {
  switch (object) {
    case Reasoning.REASONING_UNSPECIFIED:
      return "REASONING_UNSPECIFIED";
    case Reasoning.REASONING_LOW:
      return "REASONING_LOW";
    case Reasoning.REASONING_MEDIUM:
      return "REASONING_MEDIUM";
    case Reasoning.REASONING_HIGH:
      return "REASONING_HIGH";
    case Reasoning.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** SectionType defines the different sections of the report that can be modified. */
export enum SectionType {
  RECOMMENDATIONS = 0,
  ALTERNATIVES = 1,
  CONSIDERATIONS = 2,
  UNRECOGNIZED = -1,
}

export function sectionTypeFromJSON(object: any): SectionType {
  switch (object) {
    case 0:
    case "RECOMMENDATIONS":
      return SectionType.RECOMMENDATIONS;
    case 1:
    case "ALTERNATIVES":
      return SectionType.ALTERNATIVES;
    case 2:
    case "CONSIDERATIONS":
      return SectionType.CONSIDERATIONS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SectionType.UNRECOGNIZED;
  }
}

export function sectionTypeToJSON(object: SectionType): string {
  switch (object) {
    case SectionType.RECOMMENDATIONS:
      return "RECOMMENDATIONS";
    case SectionType.ALTERNATIVES:
      return "ALTERNATIVES";
    case SectionType.CONSIDERATIONS:
      return "CONSIDERATIONS";
    case SectionType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Admin {
  id: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  phoneNumber: string;
  jobRole?: string | undefined;
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
}

export interface Provider {
  id: string;
  emailAddress: string;
  phoneNumber?: string | undefined;
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
  name?: string | undefined;
  registrationComplete?: boolean | undefined;
  npi?: string | undefined;
  institutionOrPractice?: string | undefined;
  acceptedTermsOfService?: boolean | undefined;
  referralType?: string | undefined;
  referralName?: string | undefined;
  caseCount?: number | undefined;
  avgRating?: number | undefined;
  location?: string | undefined;
}

export interface Reviewer {
  id: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  phoneNumber: string;
  medicalSchool?: string | undefined;
  degree?: string | undefined;
  hospitalOrPractice: string;
  city: string;
  state: string;
  specialty: string;
  mfaEnabled: boolean;
  notificationChannels: { [key: string]: any } | undefined;
  notificationSettings: { [key: string]: any } | undefined;
  isActive: boolean;
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
}

export interface Section {
  /** The type of section being modified. Determines the prompt template used. */
  sectionType?: SectionType | undefined;
  title?:
    | string
    | undefined;
  /** The current markdown content of the section. Injected into the prompt as {Insert current [Section] tab markdown}. */
  content?:
    | string
    | undefined;
  /** List of feedback strings. The last item is used as the specific request for modification: {Insert request}. */
  humanFeedback: string[];
  /** The original content before any human feedback with ai generation is taken into account. */
  originalContent?: string | undefined;
}

function createBaseAdmin(): Admin {
  return {
    id: "",
    firstName: "",
    lastName: "",
    emailAddress: "",
    phoneNumber: "",
    jobRole: undefined,
    createdAt: undefined,
    updatedAt: undefined,
  };
}

export const Admin: MessageFns<Admin> = {
  encode(message: Admin, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.firstName !== "") {
      writer.uint32(18).string(message.firstName);
    }
    if (message.lastName !== "") {
      writer.uint32(26).string(message.lastName);
    }
    if (message.emailAddress !== "") {
      writer.uint32(34).string(message.emailAddress);
    }
    if (message.phoneNumber !== "") {
      writer.uint32(42).string(message.phoneNumber);
    }
    if (message.jobRole !== undefined) {
      writer.uint32(50).string(message.jobRole);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(58).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Admin {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdmin();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.firstName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.lastName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.emailAddress = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.phoneNumber = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.jobRole = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Admin {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      firstName: isSet(object.firstName)
        ? globalThis.String(object.firstName)
        : isSet(object.first_name)
        ? globalThis.String(object.first_name)
        : "",
      lastName: isSet(object.lastName)
        ? globalThis.String(object.lastName)
        : isSet(object.last_name)
        ? globalThis.String(object.last_name)
        : "",
      emailAddress: isSet(object.emailAddress)
        ? globalThis.String(object.emailAddress)
        : isSet(object.email_address)
        ? globalThis.String(object.email_address)
        : "",
      phoneNumber: isSet(object.phoneNumber)
        ? globalThis.String(object.phoneNumber)
        : isSet(object.phone_number)
        ? globalThis.String(object.phone_number)
        : "",
      jobRole: isSet(object.jobRole)
        ? globalThis.String(object.jobRole)
        : isSet(object.job_role)
        ? globalThis.String(object.job_role)
        : undefined,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
    };
  },

  toJSON(message: Admin): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.firstName !== "") {
      obj.firstName = message.firstName;
    }
    if (message.lastName !== "") {
      obj.lastName = message.lastName;
    }
    if (message.emailAddress !== "") {
      obj.emailAddress = message.emailAddress;
    }
    if (message.phoneNumber !== "") {
      obj.phoneNumber = message.phoneNumber;
    }
    if (message.jobRole !== undefined) {
      obj.jobRole = message.jobRole;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Admin>, I>>(base?: I): Admin {
    return Admin.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Admin>, I>>(object: I): Admin {
    const message = createBaseAdmin();
    message.id = object.id ?? "";
    message.firstName = object.firstName ?? "";
    message.lastName = object.lastName ?? "";
    message.emailAddress = object.emailAddress ?? "";
    message.phoneNumber = object.phoneNumber ?? "";
    message.jobRole = object.jobRole ?? undefined;
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    return message;
  },
};

function createBaseProvider(): Provider {
  return {
    id: "",
    emailAddress: "",
    phoneNumber: undefined,
    createdAt: undefined,
    updatedAt: undefined,
    name: undefined,
    registrationComplete: undefined,
    npi: undefined,
    institutionOrPractice: undefined,
    acceptedTermsOfService: undefined,
    referralType: undefined,
    referralName: undefined,
    caseCount: undefined,
    avgRating: undefined,
    location: undefined,
  };
}

export const Provider: MessageFns<Provider> = {
  encode(message: Provider, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.emailAddress !== "") {
      writer.uint32(18).string(message.emailAddress);
    }
    if (message.phoneNumber !== undefined) {
      writer.uint32(26).string(message.phoneNumber);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(34).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(42).fork()).join();
    }
    if (message.name !== undefined) {
      writer.uint32(50).string(message.name);
    }
    if (message.registrationComplete !== undefined) {
      writer.uint32(56).bool(message.registrationComplete);
    }
    if (message.npi !== undefined) {
      writer.uint32(66).string(message.npi);
    }
    if (message.institutionOrPractice !== undefined) {
      writer.uint32(74).string(message.institutionOrPractice);
    }
    if (message.acceptedTermsOfService !== undefined) {
      writer.uint32(80).bool(message.acceptedTermsOfService);
    }
    if (message.referralType !== undefined) {
      writer.uint32(90).string(message.referralType);
    }
    if (message.referralName !== undefined) {
      writer.uint32(98).string(message.referralName);
    }
    if (message.caseCount !== undefined) {
      writer.uint32(104).int64(message.caseCount);
    }
    if (message.avgRating !== undefined) {
      writer.uint32(113).double(message.avgRating);
    }
    if (message.location !== undefined) {
      writer.uint32(122).string(message.location);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Provider {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProvider();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.emailAddress = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.phoneNumber = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.registrationComplete = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.npi = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.institutionOrPractice = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.acceptedTermsOfService = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.referralType = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.referralName = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.caseCount = longToNumber(reader.int64());
          continue;
        }
        case 14: {
          if (tag !== 113) {
            break;
          }

          message.avgRating = reader.double();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.location = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Provider {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      emailAddress: isSet(object.emailAddress)
        ? globalThis.String(object.emailAddress)
        : isSet(object.email_address)
        ? globalThis.String(object.email_address)
        : "",
      phoneNumber: isSet(object.phoneNumber)
        ? globalThis.String(object.phoneNumber)
        : isSet(object.phone_number)
        ? globalThis.String(object.phone_number)
        : undefined,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      registrationComplete: isSet(object.registrationComplete)
        ? globalThis.Boolean(object.registrationComplete)
        : isSet(object.registration_complete)
        ? globalThis.Boolean(object.registration_complete)
        : undefined,
      npi: isSet(object.npi) ? globalThis.String(object.npi) : undefined,
      institutionOrPractice: isSet(object.institutionOrPractice)
        ? globalThis.String(object.institutionOrPractice)
        : isSet(object.institution_or_practice)
        ? globalThis.String(object.institution_or_practice)
        : undefined,
      acceptedTermsOfService: isSet(object.acceptedTermsOfService)
        ? globalThis.Boolean(object.acceptedTermsOfService)
        : isSet(object.accepted_terms_of_service)
        ? globalThis.Boolean(object.accepted_terms_of_service)
        : undefined,
      referralType: isSet(object.referralType)
        ? globalThis.String(object.referralType)
        : isSet(object.referral_type)
        ? globalThis.String(object.referral_type)
        : undefined,
      referralName: isSet(object.referralName)
        ? globalThis.String(object.referralName)
        : isSet(object.referral_name)
        ? globalThis.String(object.referral_name)
        : undefined,
      caseCount: isSet(object.caseCount)
        ? globalThis.Number(object.caseCount)
        : isSet(object.case_count)
        ? globalThis.Number(object.case_count)
        : undefined,
      avgRating: isSet(object.avgRating)
        ? globalThis.Number(object.avgRating)
        : isSet(object.avg_rating)
        ? globalThis.Number(object.avg_rating)
        : undefined,
      location: isSet(object.location) ? globalThis.String(object.location) : undefined,
    };
  },

  toJSON(message: Provider): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.emailAddress !== "") {
      obj.emailAddress = message.emailAddress;
    }
    if (message.phoneNumber !== undefined) {
      obj.phoneNumber = message.phoneNumber;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.registrationComplete !== undefined) {
      obj.registrationComplete = message.registrationComplete;
    }
    if (message.npi !== undefined) {
      obj.npi = message.npi;
    }
    if (message.institutionOrPractice !== undefined) {
      obj.institutionOrPractice = message.institutionOrPractice;
    }
    if (message.acceptedTermsOfService !== undefined) {
      obj.acceptedTermsOfService = message.acceptedTermsOfService;
    }
    if (message.referralType !== undefined) {
      obj.referralType = message.referralType;
    }
    if (message.referralName !== undefined) {
      obj.referralName = message.referralName;
    }
    if (message.caseCount !== undefined) {
      obj.caseCount = Math.round(message.caseCount);
    }
    if (message.avgRating !== undefined) {
      obj.avgRating = message.avgRating;
    }
    if (message.location !== undefined) {
      obj.location = message.location;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Provider>, I>>(base?: I): Provider {
    return Provider.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Provider>, I>>(object: I): Provider {
    const message = createBaseProvider();
    message.id = object.id ?? "";
    message.emailAddress = object.emailAddress ?? "";
    message.phoneNumber = object.phoneNumber ?? undefined;
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.name = object.name ?? undefined;
    message.registrationComplete = object.registrationComplete ?? undefined;
    message.npi = object.npi ?? undefined;
    message.institutionOrPractice = object.institutionOrPractice ?? undefined;
    message.acceptedTermsOfService = object.acceptedTermsOfService ?? undefined;
    message.referralType = object.referralType ?? undefined;
    message.referralName = object.referralName ?? undefined;
    message.caseCount = object.caseCount ?? undefined;
    message.avgRating = object.avgRating ?? undefined;
    message.location = object.location ?? undefined;
    return message;
  },
};

function createBaseReviewer(): Reviewer {
  return {
    id: "",
    firstName: "",
    lastName: "",
    emailAddress: "",
    phoneNumber: "",
    medicalSchool: undefined,
    degree: undefined,
    hospitalOrPractice: "",
    city: "",
    state: "",
    specialty: "",
    mfaEnabled: false,
    notificationChannels: undefined,
    notificationSettings: undefined,
    isActive: false,
    createdAt: undefined,
    updatedAt: undefined,
  };
}

export const Reviewer: MessageFns<Reviewer> = {
  encode(message: Reviewer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.firstName !== "") {
      writer.uint32(18).string(message.firstName);
    }
    if (message.lastName !== "") {
      writer.uint32(26).string(message.lastName);
    }
    if (message.emailAddress !== "") {
      writer.uint32(34).string(message.emailAddress);
    }
    if (message.phoneNumber !== "") {
      writer.uint32(42).string(message.phoneNumber);
    }
    if (message.medicalSchool !== undefined) {
      writer.uint32(50).string(message.medicalSchool);
    }
    if (message.degree !== undefined) {
      writer.uint32(58).string(message.degree);
    }
    if (message.hospitalOrPractice !== "") {
      writer.uint32(66).string(message.hospitalOrPractice);
    }
    if (message.city !== "") {
      writer.uint32(74).string(message.city);
    }
    if (message.state !== "") {
      writer.uint32(82).string(message.state);
    }
    if (message.specialty !== "") {
      writer.uint32(90).string(message.specialty);
    }
    if (message.mfaEnabled !== false) {
      writer.uint32(96).bool(message.mfaEnabled);
    }
    if (message.notificationChannels !== undefined) {
      Struct.encode(Struct.wrap(message.notificationChannels), writer.uint32(106).fork()).join();
    }
    if (message.notificationSettings !== undefined) {
      Struct.encode(Struct.wrap(message.notificationSettings), writer.uint32(114).fork()).join();
    }
    if (message.isActive !== false) {
      writer.uint32(120).bool(message.isActive);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(130).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(138).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Reviewer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReviewer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.firstName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.lastName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.emailAddress = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.phoneNumber = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.medicalSchool = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.degree = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.hospitalOrPractice = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.city = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.state = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.specialty = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.mfaEnabled = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.notificationChannels = Struct.unwrap(Struct.decode(reader, reader.uint32()));
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.notificationSettings = Struct.unwrap(Struct.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.isActive = reader.bool();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Reviewer {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      firstName: isSet(object.firstName)
        ? globalThis.String(object.firstName)
        : isSet(object.first_name)
        ? globalThis.String(object.first_name)
        : "",
      lastName: isSet(object.lastName)
        ? globalThis.String(object.lastName)
        : isSet(object.last_name)
        ? globalThis.String(object.last_name)
        : "",
      emailAddress: isSet(object.emailAddress)
        ? globalThis.String(object.emailAddress)
        : isSet(object.email_address)
        ? globalThis.String(object.email_address)
        : "",
      phoneNumber: isSet(object.phoneNumber)
        ? globalThis.String(object.phoneNumber)
        : isSet(object.phone_number)
        ? globalThis.String(object.phone_number)
        : "",
      medicalSchool: isSet(object.medicalSchool)
        ? globalThis.String(object.medicalSchool)
        : isSet(object.medical_school)
        ? globalThis.String(object.medical_school)
        : undefined,
      degree: isSet(object.degree) ? globalThis.String(object.degree) : undefined,
      hospitalOrPractice: isSet(object.hospitalOrPractice)
        ? globalThis.String(object.hospitalOrPractice)
        : isSet(object.hospital_or_practice)
        ? globalThis.String(object.hospital_or_practice)
        : "",
      city: isSet(object.city) ? globalThis.String(object.city) : "",
      state: isSet(object.state) ? globalThis.String(object.state) : "",
      specialty: isSet(object.specialty) ? globalThis.String(object.specialty) : "",
      mfaEnabled: isSet(object.mfaEnabled)
        ? globalThis.Boolean(object.mfaEnabled)
        : isSet(object.mfa_enabled)
        ? globalThis.Boolean(object.mfa_enabled)
        : false,
      notificationChannels: isObject(object.notificationChannels)
        ? object.notificationChannels
        : isObject(object.notification_channels)
        ? object.notification_channels
        : undefined,
      notificationSettings: isObject(object.notificationSettings)
        ? object.notificationSettings
        : isObject(object.notification_settings)
        ? object.notification_settings
        : undefined,
      isActive: isSet(object.isActive)
        ? globalThis.Boolean(object.isActive)
        : isSet(object.is_active)
        ? globalThis.Boolean(object.is_active)
        : false,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
    };
  },

  toJSON(message: Reviewer): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.firstName !== "") {
      obj.firstName = message.firstName;
    }
    if (message.lastName !== "") {
      obj.lastName = message.lastName;
    }
    if (message.emailAddress !== "") {
      obj.emailAddress = message.emailAddress;
    }
    if (message.phoneNumber !== "") {
      obj.phoneNumber = message.phoneNumber;
    }
    if (message.medicalSchool !== undefined) {
      obj.medicalSchool = message.medicalSchool;
    }
    if (message.degree !== undefined) {
      obj.degree = message.degree;
    }
    if (message.hospitalOrPractice !== "") {
      obj.hospitalOrPractice = message.hospitalOrPractice;
    }
    if (message.city !== "") {
      obj.city = message.city;
    }
    if (message.state !== "") {
      obj.state = message.state;
    }
    if (message.specialty !== "") {
      obj.specialty = message.specialty;
    }
    if (message.mfaEnabled !== false) {
      obj.mfaEnabled = message.mfaEnabled;
    }
    if (message.notificationChannels !== undefined) {
      obj.notificationChannels = message.notificationChannels;
    }
    if (message.notificationSettings !== undefined) {
      obj.notificationSettings = message.notificationSettings;
    }
    if (message.isActive !== false) {
      obj.isActive = message.isActive;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Reviewer>, I>>(base?: I): Reviewer {
    return Reviewer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Reviewer>, I>>(object: I): Reviewer {
    const message = createBaseReviewer();
    message.id = object.id ?? "";
    message.firstName = object.firstName ?? "";
    message.lastName = object.lastName ?? "";
    message.emailAddress = object.emailAddress ?? "";
    message.phoneNumber = object.phoneNumber ?? "";
    message.medicalSchool = object.medicalSchool ?? undefined;
    message.degree = object.degree ?? undefined;
    message.hospitalOrPractice = object.hospitalOrPractice ?? "";
    message.city = object.city ?? "";
    message.state = object.state ?? "";
    message.specialty = object.specialty ?? "";
    message.mfaEnabled = object.mfaEnabled ?? false;
    message.notificationChannels = object.notificationChannels ?? undefined;
    message.notificationSettings = object.notificationSettings ?? undefined;
    message.isActive = object.isActive ?? false;
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    return message;
  },
};

function createBaseSection(): Section {
  return {
    sectionType: undefined,
    title: undefined,
    content: undefined,
    humanFeedback: [],
    originalContent: undefined,
  };
}

export const Section: MessageFns<Section> = {
  encode(message: Section, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sectionType !== undefined) {
      writer.uint32(8).int32(message.sectionType);
    }
    if (message.title !== undefined) {
      writer.uint32(18).string(message.title);
    }
    if (message.content !== undefined) {
      writer.uint32(26).string(message.content);
    }
    for (const v of message.humanFeedback) {
      writer.uint32(34).string(v!);
    }
    if (message.originalContent !== undefined) {
      writer.uint32(42).string(message.originalContent);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Section {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.sectionType = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.content = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.humanFeedback.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.originalContent = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Section {
    return {
      sectionType: isSet(object.sectionType)
        ? sectionTypeFromJSON(object.sectionType)
        : isSet(object.section_type)
        ? sectionTypeFromJSON(object.section_type)
        : undefined,
      title: isSet(object.title) ? globalThis.String(object.title) : undefined,
      content: isSet(object.content) ? globalThis.String(object.content) : undefined,
      humanFeedback: globalThis.Array.isArray(object?.humanFeedback)
        ? object.humanFeedback.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.human_feedback)
        ? object.human_feedback.map((e: any) => globalThis.String(e))
        : [],
      originalContent: isSet(object.originalContent)
        ? globalThis.String(object.originalContent)
        : isSet(object.original_content)
        ? globalThis.String(object.original_content)
        : undefined,
    };
  },

  toJSON(message: Section): unknown {
    const obj: any = {};
    if (message.sectionType !== undefined) {
      obj.sectionType = sectionTypeToJSON(message.sectionType);
    }
    if (message.title !== undefined) {
      obj.title = message.title;
    }
    if (message.content !== undefined) {
      obj.content = message.content;
    }
    if (message.humanFeedback?.length) {
      obj.humanFeedback = message.humanFeedback;
    }
    if (message.originalContent !== undefined) {
      obj.originalContent = message.originalContent;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Section>, I>>(base?: I): Section {
    return Section.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Section>, I>>(object: I): Section {
    const message = createBaseSection();
    message.sectionType = object.sectionType ?? undefined;
    message.title = object.title ?? undefined;
    message.content = object.content ?? undefined;
    message.humanFeedback = object.humanFeedback?.map((e) => e) || [];
    message.originalContent = object.originalContent ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
